import { render } from "./Activation.vue?vue&type=template&id=9cfe7e46&scoped=true"
import script from "./Activation.vue?vue&type=script&lang=js"
export * from "./Activation.vue?vue&type=script&lang=js"

import "./Activation.vue?vue&type=style&index=0&id=9cfe7e46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cfe7e46"]])

export default __exports__